import axios from "axios";
import { getCountrySuccess, updateTrustPilotReviewCount } from "./appReducer";
import config from "@Config/index";
import getUserCountry from "@Pages/Search/components/SearchList/components/TrustPilotBanner/helper";

class AppDispacher {
  private dispatch;

  constructor(dispatch: any) {
    this.dispatch = dispatch;
  }

  async fetchCountryData() {
    const cachedCountry = typeof window !== "undefined" ? localStorage.getItem("country") : null;
    if (cachedCountry) {
      this.dispatch(getCountrySuccess(cachedCountry));
      return;
    }

    try {
      const data = await getUserCountry();
      if (data?.country) {
        if (typeof window !== "undefined") {
          localStorage.setItem("country", data.country);
          if (data.city) {
            localStorage.setItem("city", data.city);
          }
        }
        this.dispatch(getCountrySuccess(data.country));
      }
    } catch (error) {
      console.error("Error in fetchCountryData:", error);
    }
  }

  async fetchGlobalTrustPilotRating() {
    try {
      const { data } = await axios.get(
        `${config.API_URL}/api/v0/trustpilot_review/get_trustpilot_reviews_count`,
      );
      // eslint-disable-next-line radix
      this.dispatch(updateTrustPilotReviewCount(parseInt(data?.data?.count || "8300")));
    } catch (error) {
      this.dispatch(updateTrustPilotReviewCount(8300));
    }
  }
}

export default AppDispacher;
